import { putChannelRule } from '../../services/api/channelRule.api';
import { PUT_CHANNEL_RULE_REQUEST, PUT_CHANNEL_RULE_SUCCESS, PUT_CHANNEL_RULE_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[PUT_CHANNEL_RULE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[PUT_CHANNEL_RULE_SUCCESS](state) {
			state.isLoading = false;
		},
		[PUT_CHANNEL_RULE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateChannelRule({ commit }, { id, params }) {
			try {
				commit(PUT_CHANNEL_RULE_REQUEST);
				await putChannelRule(id, params);
				commit(PUT_CHANNEL_RULE_SUCCESS);
			} catch (error) {
				commit(PUT_CHANNEL_RULE_FAILURE, error);
			}
		},
	},
};